import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    Input,
    Output,
    EventEmitter,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { fromEvent, Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged, finalize, takeUntil } from "rxjs/operators";
import { MatDialog } from "@angular/material/dialog";

import { fuseAnimations } from "@fuse/animations";

import { ServicioCotizadoDTO } from "app/main/apps/shared/interfaces/servicio-cotizado.interface";
import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { CotizacionesService } from "app/main/apps/shared/services/rest/cotizaciones.service";
import { CotizacionDTO } from "app/main/apps/shared/interfaces/cotizacion.interface";
import { OnDestroy } from "@angular/core";
import { DialogActualizarVigenciaComponent } from "../../../cotizaciones/components/dialog-actualizar-vigencia/dialog-actualizar-vigencia.component";
import { DialogService } from "app/main/apps/shared/services/rest/dialog.service";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { NotificacionesService } from "app/main/apps/shared/services/rest/notificaciones.service";
import { Moment } from "moment";

@Component({
    selector: "app-servicios-cotizacion",
    templateUrl: "./servicios-cotizacion.component.html",
    styleUrls: ["./servicios-cotizacion.component.scss"],
    animations: fuseAnimations,
})
export class ServiciosCotizacionComponent implements OnInit, OnDestroy {
    cotizacion: CotizacionDTO;

    @Output()
    solicitarServicio: EventEmitter<ServicioCotizadoDTO> = new EventEmitter();

    @Output()
    rechazarServicio: EventEmitter<ServicioCotizadoDTO> = new EventEmitter();

    @Output()
    verDetalleServicioEvent: EventEmitter<ServicioCotizadoDTO> = new EventEmitter();

    @Output()
    cotizarServicio: EventEmitter<ServicioCotizadoDTO> = new EventEmitter();

    @Output()
    invitar: EventEmitter<ServicioCotizadoDTO> = new EventEmitter();

    @Output()
    refrescarDatos: EventEmitter<number> = new EventEmitter();

    

    dataSource: MatTableDataSource<ServicioCotizadoDTO>;
    displayedColumns = [
        "descripcion",
        "estado",
        "cliente",
        "sucursal",
        "cantidad",
        "tiempo",
        "valorUF",
        "acciones",
    ];

    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;

    @ViewChild("filter", { static: true })
    filter: ElementRef;

    private _unsubscribeAll: Subject<any>;
    subscripciones: Subscription;
    procesando:boolean=false;
    constructor(
        public dialog: MatDialog,
        public _menuUsuarioSrvc: MenuUsuarioService,
        private _cotizacionSrvc: CotizacionesService,
        private _dialogSrvc: DialogService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _notificacionSrvc: NotificacionesService,
    ) {
        this.subscripciones = new Subscription();
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.subscripciones.add(
            this._cotizacionSrvc.onServicioCotizacionChanged$.subscribe(
                (cotizacion) => {
                    this.cotizacion = cotizacion;
                    
                    console.log('cotizacion',cotizacion);
                    //this.servicios = cotizacion.servicios;
                    this.dataSource = new MatTableDataSource(
                        this.cotizacion.servicios
                    );
                    this.dataSource.paginator = this.paginator;
                    this.dataSource.sort = this.sort;
                }
            )
        );

        this.subscripciones.add(
            fromEvent(this.filter.nativeElement, "keyup")
                .pipe(
                    takeUntil(this._unsubscribeAll),
                    debounceTime(150),
                    distinctUntilChanged()
                )
                .subscribe(() => {
                    if (!this.dataSource) {
                        return;
                    }

                    this.dataSource.filter = this.filter.nativeElement.value;
                })
        );
    }

    solicitar(servicio: ServicioCotizadoDTO) {
        this.solicitarServicio.emit(servicio);
    }

    rechazar(servicio: ServicioCotizadoDTO) {
        this.rechazarServicio.emit(servicio);
    }

    cotizar(servicio: ServicioCotizadoDTO) {
        this.cotizarServicio.emit(servicio);
    }

    verDetalleServicio(servicio: ServicioCotizadoDTO) {
        this.verDetalleServicioEvent.emit(servicio);
    }

    puedeComprar(idSucursal: number) {
        return this._menuUsuarioSrvc.puedeRealizarAccion(
            idSucursal,
            "puedeComprar"
        );
    }

    invitarACotizar(servicio: ServicioCotizadoDTO) {
        this.invitar.emit(servicio);
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    /*
    solicitarActualizacion(idCotizacion: number) {
        this.solicitarActualizacionEvent.emit(idCotizacion);
    }

    actualizarVigencia(idCotizacion: number) {
        this.actualizarVigenciaEvent.emit(idCotizacion);
    }
    */



    solicitarActualizacion(idCotizacion: number) {
        //console.log(idCotizacion);
        this.procesando = true;
        this._fuseProgressBarService.show();
        this.subscripciones.add(
            this._cotizacionSrvc
                .solicitaActualizacion(idCotizacion)
                .pipe(
                    finalize(() => {
                        this._fuseProgressBarService.hide();
                        this.procesando = false;
                    })
                )
                .subscribe((reps) =>
                    this._notificacionSrvc.mostrarNotificacion(
                        "Solicitud de actualización de cotización enviada",
                        "success"
                    )
                )
        );
    }

    actualizarVigencia(idCotizacion: number) {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogActualizarVigenciaComponent,
            "clase-dialog",
            "600px"
        );

        dialogRef.afterClosed().subscribe((result: { fecha: Moment }) => {
            if (result) {
                this.subscripciones.add(
                    this._cotizacionSrvc
                        .actualizaVigenciaCotizacion(
                            idCotizacion,
                            result.fecha.toISOString().split("T")[0]
                        )
                        .pipe(
                            finalize(() => this._fuseProgressBarService.hide())
                        )
                        .subscribe((reps) => {
                            this._cotizacionSrvc.cotizacionesRefresh$.next(
                                true
                            );
                            //this.buscarCotizaciones();
                            this.refrescarDatos.emit(idCotizacion);
                            this._notificacionSrvc.mostrarNotificacion(
                                "Fecha de vigencia de cotización actualizada",
                                "success"
                            );
                        })
                );
            }
        });
    }

}
